export default async ({ commit, rootGetters }) => {
    let primeTime = await rootGetters['date/primeTime']

    if(primeTime) {

        let primeTimeCoef = await rootGetters['settings/pricePrimeTime']

        commit('setPricePrimeTime', {
            value: primeTimeCoef,
            coef: primeTimeCoef
        })
    } else {
        commit('setPricePrimeTime', {
            value: 1,
            coef: 1
        })
    }
}